import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import http from '../../api/http';
import { Box, Paper, Typography, Button, TextField, Alert } from '@mui/material';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AdminActivate = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const token = query.get('token') || '';
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!password) {
      setError('Password is required');
      return;
    }
    setLoading(true);
    try {
      const res = await http.post('/api/admins/auth/activate', { token, password });
      setSuccess(res.data?.message || 'Account activated successfully');
      setPassword('');
    } catch (err: any) {
      if (err?.response?.status === 404) {
        setError('Activation link is invalid or expired');
      } else {
        setError(err?.response?.data?.message || 'Activation failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f7f7' }}>
      <Paper elevation={3} sx={{ padding: 4, minWidth: 350, maxWidth: 400 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Activate Account</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success ? (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>
            <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/login')}>Go to Login</Button>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <TextField
              label="New Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              fullWidth
              required
              autoFocus
            />
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
              {loading ? 'Activating...' : 'Activate Account'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default AdminActivate; 